<template>
  <div>
    <div class="bd-header bd-header_hellomagazine">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/hello/img/logo.svg" alt="">
      </div>
    </div>
    <div class="bd-feed bd-feed_hellomagazine">
      <div class="bd-hellomagazine">
        <img
          src="/pages/hello/img/1.jpg"
          alt=""
          class="bd-hellomagazine__img bd-hellomagazine__img_no-marg">
        <div class="bd-hellomagazine__item">Кино</div>
        <div class="bd-hellomagazine__title">Шарлиз Терон, Николь Кидман, Рене Зеллвегер
        и другие гости и победители The Hollywood Film Awards</div>
        <div class="bd-hellomagazine__pre-title">Сезон вручения кинопремий
        снова в разгаре. Первые награды минувшим вечером вручили в отеле Beverly
        Hilton на ежегодной церемонии Hollywood Film Awards.</div>

        <buzzCode @ready="ready" :id="id"></buzzCode>

        <br>

        <div class="bd-hellomagazine__desc">
          Премия, учрежденная американскими кинокритиками в 1997 году, в
          Beverly Hilton проходит уже 23-й раз и неизменно собирает самых
          блистательных гостей. Недостатка в них на красной дорожке
          не было и в этот раз.  Николь Кидман, Дженнифер Гарнер,
          Рене Зеллвегер, Роберт Дауни-младший, Мэтт Деймон,
          Антонио Бандерас, Аль Пачино, Дакота Джонсон были
          среди тех знаменитостей, кто позировал этим вечером
          фотографам. Многие из них ушли с заслуженными наградами.
        </div>

        <img src="/pages/hello/img/2.jpg" alt="" class="bd-hellomagazine__img">
        <div class="bd-hellomagazine__name">Николь Кидман и Шарлиз Терон</div>

        <img src="/pages/hello/img/3.jpg" alt="" class="bd-hellomagazine__img">
        <div class="bd-hellomagazine__name">Николь Кидман</div>

        <img src="/pages/hello/img/4.jpg" alt="" class="bd-hellomagazine__img">
        <div class="bd-hellomagazine__name">Шарлиз Терон</div>

        <img src="/pages/hello/img/5.jpg" alt="" class="bd-hellomagazine__img">
        <div class="bd-hellomagazine__name">Рене Зеллвегер</div>

        <div class="bd-hellomagazine__desc">
          За карьерные достижения отметили Шарлиз Терон. Антонио Бандерас получил
          почетную статуэтку за роль в картине Педро
          Альмодовара "Боль и слава". А Рене Зеллвегер была
          названа лучшей актрисой года - за изображение
          удивительной Джуди Гарленд в фильме Руперта Гулда "Джуди".
        </div>

        <img src="/pages/hello/img/6.jpg" alt="" class="bd-hellomagazine__img">
        <div class="bd-hellomagazine__name">Мэтт Деймон и Кристиан Бэйл</div>

        <img src="/pages/hello/img/7.jpg" alt="" class="bd-hellomagazine__img">
        <div class="bd-hellomagazine__name">Дакота Джонсон и Антонио Бандерас</div>

        <img src="/pages/hello/img/8.jpg" alt="" class="bd-hellomagazine__img">
        <div class="bd-hellomagazine__name">Шайа Лабаф, Роберт Дауни-младший</div>

        <div class="bd-hellomagazine__tags">
          <div class="bd-hellomagazine__tag">Мэтт Дэймон</div>
          <div class="bd-hellomagazine__tag">Николь Кидман</div>
          <div class="bd-hellomagazine__tag">Шарлиз Терон</div>
          <div class="bd-hellomagazine__tag">Рене Зеллвегер</div>
          <div class="bd-hellomagazine__tag">Кристиан Бэйл</div>
          <div class="bd-hellomagazine__tag">Дакота Джонсон</div>
          <div class="bd-hellomagazine__tag">Антонио Бандерас</div>
          <div class="bd-hellomagazine__tag">Шайа Лабаф</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'hello',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    display flex
    flex-flow row nowrap
    position fixed
    z-index 999
    align-items center
    align-content space-around
    width 100%
    &_hellomagazine
      background-color white
      & ^[1]__menu
        width 30px
        height 30px
        margin 15px
        fill black
      & ^[0]-ht__img
        width 80px
        height auto
        margin 0 auto
      & ^[1]__title
        width 100%
        padding-right 60px
        box-sizing border-box
        text-align center
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-hellomagazine
    padding 20px
    background white
    font-family Roboto, "Helvetica Neue", Arial, sans-serif
    font-size 1rem
    font-weight 400
    line-height 1.5
    text-align left
    &__img
      display block
      width 100%
      height auto
      margin 30px auto 30px
      &_no-marg
        margin 0 auto
    &__item
      margin 30px auto 20px
      color #000
      font-size 10px
      font-family 'Roboto', sans-serif
      text-decoration underline
      text-transform uppercase
      text-align center
    &__title
      padding 0px 20px
      margin 0px auto 20px
      font-family 'PT Serif', Arial, serif
      font-size 19px
      font-weight bold
      line-height 22px
      text-align center
    &__pre-title
      margin-bottom 30px
      font-size 16px
      line-height 22px
      font-weight 300
      text-align center
    &__desc
      margin-bottom 15px
      font-size 14px
      line-height 22px
    &__name
      color #666666
      font-size 13px
      line-height 18px
      margin-top 0px
      margin-bottom 50px
      display block
      text-align center
    &__tags
      display flex
      flex-wrap wrap
      margin 50px -10px 0
    &__tag
      display block
      margin 10px
      padding 8px 17px
      border 1px solid #999999
      background transparent
      font-family 'Roboto', Arial, serif
      font-size 10px
      line-height 10px
      font-weight 500
      color #ed1c24
      text-align center
      text-transform uppercase
      text-decoration none
      -webkit-appearance none
      cursor pointer
</style>
